export default function validateFields(fields, values) {
  let validated = true
  fields.map((field) => {
    if (!values[field] || values[field] === '') {
      validated = false
    }
  })
  return validated
}